import {
  Component, EventEmitter, OnInit, Output,
} from '@angular/core';
import { IStep } from '../utils/interfaces/step.interface';

@Component({
  selector: 'ba-authorization-step',
  templateUrl: './authorization-step.component.html',
  styleUrls: ['./authorization-step.component.scss'],
})
export class AuthorizationStepComponent implements OnInit, IStep<void> {
  @Output() stepDone = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }
}
